// extracted by mini-css-extract-plugin
export default {"container":"rVG39","title-section":"_24gAi","body-section":"M1mPx"};